export interface Testimonial {
  id: string;
  name: string;
  role: string;
  message: string;
  rating: number;
  avatar: string;
  product?: string;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Samira V.',
    role: 'Moeder, Amsterdam',
    message: 'Ik gebruik de Blue Protect Soap al 3 maanden elke ochtend. Het verschil is echt merkbaar — ik voel me lichter, minder belast. Mijn kinderen krijgen het ook en ik merk dat ze rustiger zijn. Dit is het puurste product dat ik ooit heb gebruikt.',
    rating: 5,
    avatar: 'https://public.readdy.ai/ai/img_res/d1e1777e7571cbeac9b0cbe077bc8ef6.jpg',
    product: 'Blue Protect Soap',
  },
  {
    id: '2',
    name: 'Yasmine B.',
    role: 'Ondernemer, Rotterdam',
    message: 'Nadat ik de Blue Protect Balls in mijn winkel heb geplaatst is de sfeer compleet veranderd. Klanten voelen het ook — ze zeggen dat het er zo rustig aanvoelt. Ik vertrouw dit product omdat het puur natuur is, geen chemische rommel zoals bij andere merken.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=young%20professional%20woman%20entrepreneur%20confident%20happy%20smile%20warm%20portrait%20natural%20light%20studio%20beautiful%20dark%20hair&width=100&height=100&seq=bptest2&orientation=squarish',
    product: 'Blue Protect Balls',
  },
  {
    id: '3',
    name: 'Miriam S.',
    role: 'Verpleegkundige, Utrecht',
    message: 'Ik heb altijd geloofd in de traditie van blauwe bescherming van mijn voorouders. Dit is het enige merk dat het echt puur maakt — zonder toevoegingen zoals andere merken die gebruiken. De Blue Protect Powder strooi ik elke week bij mijn voordeur. Het werkt.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=hindustani%20dutch%20woman%20healthcare%20worker%20kind%20warm%20smile%20portrait%20natural%20light%20beautiful%20professional&width=100&height=100&seq=bptest3&orientation=squarish',
    product: 'Blue Protect Powder',
  },
  {
    id: '4',
    name: 'Zara N.',
    role: 'Studente, Den Haag',
    message: 'De Blue Protect Spray zit altijd in mijn tas. Na contact met moeilijke mensen of drukke plekken spray ik mezelf in en ik voel direct rust terugkomen. Het ruikt heerlijk en ik weet dat het puur is — geen nep-blauw zoals je bij andere merken krijgt.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=young%20surinamese%20woman%20student%20happy%20smiling%20warm%20portrait%20natural%20outdoor%20light%20confident%20beautiful%20youthful&width=100&height=100&seq=bptest4&orientation=squarish',
    product: 'Blue Protect Spray',
  },
  {
    id: '5',
    name: 'Fatima O.',
    role: 'Life Coach, Groningen',
    message: 'Ik beveel Blue Protect aan al mijn cliënten aan. De hele serie is gebaseerd op ons voorouderlijk erfgoed en dat voel je. Geen andere producten geven dit gevoel van authenticiteit. Mijn cliënten vragen er altijd naar na een sessie.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=mature%20professional%20woman%20life%20coach%20warm%20confident%20smile%20portrait%20studio%20light%20elegant%20natural%20diverse%20beautiful&width=100&height=100&seq=bptest5&orientation=squarish',
    product: 'Blue Protect Serie',
  },
  {
    id: '6',
    name: 'Layla K.',
    role: 'Moeder van 3, Breda',
    message: 'Na de bevalling van mijn jongste heb ik de Blue Protect Soap en Spray gebruikt voor bescherming van mijn baby. Mijn oma deed dit ook altijd — het is onze cultuur. Eindelijk een product dat het echt traditioneel en puur doet, niet nagemaakt.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=surinamese%20woman%20mother%20loving%20warm%20smile%20portrait%20natural%20home%20light%20soft%20welcoming%20beautiful%20dark%20hair&width=100&height=100&seq=bptest6&orientation=squarish',
    product: 'Blue Protect Soap + Spray',
  },
];
